import { type MovieSortBy, type TvSortBy } from '@tmdb-graphql-api/schema/types';
import { usePathname, useRouter, useSearchParams } from 'next/navigation.js';

export const DISCOVER_SORT_BY = 'discoverSortBy';

export const useDiscoverSortByParam = (): [TvSortBy | MovieSortBy, (value: TvSortBy | MovieSortBy) => void] => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const setParam = (value: TvSortBy | MovieSortBy) => {
    const newSearchParams = new URLSearchParams(searchParams.toString());

    if (newSearchParams.has(DISCOVER_SORT_BY)) {
      newSearchParams.set(DISCOVER_SORT_BY, value);
    } else {
      newSearchParams.append(DISCOVER_SORT_BY, value);
    }

    if (newSearchParams.size > 0) {
      router.push(`${pathname}?${newSearchParams.toString()}`, { scroll: false });
    } else {
      router.push(pathname, { scroll: false });
    }
  };

  // searchParams.get does not support generics
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  return [(searchParams.get(DISCOVER_SORT_BY) ?? 'POPULARITY_DESC') as TvSortBy | MovieSortBy, setParam];
};
